import jwt from "jsonwebtoken";

// 图片上传地址
// const uploadUrl = "http://172.130.60.163:8082/upload/";
const uploadUrl = "https://oss-eu.xcharge.com/image/";

const checkToken = function(history) {
  let token = localStorage.getItem("token");
  let decoded = jwt.decode(token, "secret");
  if (token) {
    if (decoded.exp <= Date.now() / 1000) {
      history.push("/login");
    }
  } else {
    history.push("/login");
  }
};

export { uploadUrl, checkToken };



// WEBPACK FOOTER //
// ./src/components/common/Tool.js